"use strict";
const {
    PAGE_CUSTOMER,
    PAGE_CART,
    PAGE_STORE,
    PAGE_INSTANCE
} = require("./Base");

const PLCC_FORM_START = {
    eventName: "plccFormStart",
    eventData: {}
};

const PLCC_FORM_SUBMIT = {
    eventName: "plccFormSubmit",
    eventData: {
        customer: {
            plccApplicationStatus : ""
        }
    }
};

const PAGE_LOAD = {
    eventName: "pageLoaded",
    eventData: {
        customer: {
            ...PAGE_CUSTOMER,
            ...PAGE_CART,
            ...PAGE_STORE
        },
        page: {
            ...PAGE_INSTANCE,
            name: "",
            type: "",
        }
    }
};

module.exports = {
    PLCC_FORM_START,
    PLCC_FORM_SUBMIT,
    PAGE_LOAD
};
